// src/screens/ProveedorCotizacionesScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import {
        IoArrowBack,
        // eslint-disable-next-line no-unused-vars
        IoTimeOutline,
        IoPersonOutline,
        IoBusinessOutline,
        IoFlashOutline,
        IoCheckmarkCircle
} from 'react-icons/io5';
import moment from 'moment';
import 'moment/locale/es';
import './ProveedorCotizacionesScreen.css';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';

function ProveedorCotizacionesScreen() {
        const navigate = useNavigate();
        const { userData } = useAuth();
        const [cotizaciones, setCotizaciones] = useState([]);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
                if (!userData || !userData.proveedorId) {
                        if (userData && !userData.proveedorId) {
                                setLoading(false);
                        }
                        return;
                }

                const providerId = userData.proveedorId;
                setLoading(true);

                const q = query(
                        collection(db, "cotizaciones"),
                        where("proveedorId", "==", providerId),
                        where("estatus", "in", ["pendiente_proveedor", "cambio_fecha_solicitado"]),
                        orderBy("fechaCreacion", "desc")
                );

                const unsubscribe = onSnapshot(q, (snapshot) => {
                        const listaCotizaciones = snapshot.docs.map(doc => ({
                                id: doc.id,
                                ...doc.data()
                        }));
                        setCotizaciones(listaCotizaciones);
                        setLoading(false);
                }, (error) => {
                        console.error("Error al cargar cotizaciones: ", error);
                        setLoading(false);
                });

                return () => unsubscribe();
        }, [userData]);

        return (
                <div className="ks-page">
                        <KondoSidebar activeRoute="/proveedor/cotizaciones" />
                        <main className="ks-main">
                                <div className="ks-header-sticky-wrapper">
                                        <KondoBrandHeader showBack={false} />
                                </div>
                                <div className="ks-scroll-area">
                                        <div className="muro-header-stitch">
                                                <div className="muro-hero-card">
                                                        <div className="muro-hero-content">
                                                                <h1>Solicitudes</h1>
                                                                <p>Gestión de Oportunidades</p>
                                                        </div>
                                                        <IoFlashOutline className="muro-hero-icon-decor" />
                                                </div>
                                        </div>
                                        <div className="provider-quotes-container">

                                                <div className="provider-quotes-content">
                                {loading ? (
                                        <p style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>Cargando...</p>
                                ) : cotizaciones.length === 0 ? (
                                        <div className="empty-quotes">
                                                <IoCheckmarkCircle size={60} className="empty-hero-icon" />
                                                <h3 style={{ color: '#111827', margin: '0 0 5px' }}>¡Estás al día!</h3>
                                                <p style={{ fontSize: '0.9rem' }}>No tienes solicitudes pendientes.</p>
                                        </div>
                                ) : (
                                        <div className="quotes-grid">
                                                {cotizaciones.map((coti) => (
                                                        <div key={coti.id} className="quote-card">
                                                                <div className="quote-header-row">
                                                                        <h3 className="quote-service-title">{coti.tipoServicio || "Solicitud"}</h3>
                                                                        <div className="quote-date-badge">
                                                                                {coti.fechaCreacion?.toDate ? moment(coti.fechaCreacion.toDate()).fromNow(true) : 'Hoy'}
                                                                        </div>
                                                                </div>

                                                                <div className="quote-details">
                                                                        <div className="quote-detail-item">
                                                                                <IoPersonOutline className="quote-detail-icon" />
                                                                                <span>{coti.nombreResidente || "Residente"}</span>
                                                                        </div>
                                                                        <div className="quote-detail-item">
                                                                                <IoBusinessOutline className="quote-detail-icon" />
                                                                                <span>{coti.nombreCondominio || "Condominio"}</span>
                                                                        </div>
                                                                </div>

                                                                {coti.descripcion && (
                                                                        <div className="quote-desc-preview">
                                                                                "{coti.descripcion}"
                                                                        </div>
                                                                )}

                                                                <button
                                                                        className={`quote-action-btn ${coti.estatus !== 'pendiente_proveedor' ? 'secondary' : ''}`}
                                                                        onClick={() => {
                                                                                if (coti.estatus === 'pendiente_proveedor') {
                                                                                        navigate(`/proveedor/cotizacion/${coti.id}`);
                                                                                } else {
                                                                                        navigate(`/marketplace/cotizacion/${coti.id}`);
                                                                                }
                                                                        }}
                                                                >
                                                                        {coti.estatus === 'pendiente_proveedor' ? 'Responder Ahora' : 'Ver Detalles'}
                                                                </button>
                                                        </div>
                                                ))}
                                        </div>
                                )}
                        </div>
                        </div>
                        </div>
                        <KondoBottomNav activeRoute="/proveedor/cotizaciones" />
                </main>
        </div>
        );
}

export default ProveedorCotizacionesScreen;